import { Button, CircularProgress } from '@mui/material';
import DialogModal from '../../components/DialogModal';
import { AddHashtagProps } from './types/HashtagTypes';
import TextInputWithIcon from '../../components/TextInputWithIcon';

const AddHashtagDialog = ({
  open,
  loading,
  hashtag,
  errors,
  onClose,
  onChange,
  onSubmit
}: AddHashtagProps) => (
  <DialogModal
    open={open}
    onClose={onClose}
    title='Add Hashtag'
    maxWidth='xs'
    actions={
      <>
        <Button variant='outlined' onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          variant='contained'
          onClick={onSubmit}
          disabled={loading || !hashtag.trim()}
        >
          {loading ? <CircularProgress size={20} /> : 'Add'}
        </Button>
      </>
    }
  >
    <TextInputWithIcon
      id='hashtag-name-input'
      label='Hashtag Name'
      margin='dense'
      placeholder='Enter hashtag'
      required
      fullWidth
      value={hashtag}
      onChange={(e) => onChange(e.target.value)}
      error={Boolean(errors.name)}
      helperText={errors.name || null}
      inputProps={{
        maxLength: 50,
        'aria-labelledby': 'hashtag-name-label'
      }}
      autoFocus
    />
  </DialogModal>
);

export default AddHashtagDialog;
